module.exports = __webpack_public_path__ + "media/images/icon__email@2x-40a88b3eaefb0dda2a4865b1b8cd7efb.png";